let scrollPosition;
let body = document.getElementsByTagName('body');
function open() {
  scrollPosition = window.scrollY;
  body[0].classList.add('fixed');
  body[0].style.top = '-' + scrollPosition + 'px';
}

function close() {
  body[0].classList.remove('fixed');
  body[0].style.top = 0;
  scrollTo(0, scrollPosition);
}

function bottom() {
  // const html = document.querySelector('html')
  // const bodyHeight = document.body.clientHeight // bodyの高さを取得
  // const windowHeight = window.innerHeight // windowの高さを取得
  // const bottomPoint = bodyHeight - windowHeight // ページ最下部までスクロールしたかを判定するための位置を計算
  //
  // window.addEventListener('scroll', () => {
  //   const currentPos = window.pageYOffset // スクロール量を取得
  //   if (bottomPoint <= currentPos) { // スクロール量が最下部の位置を過ぎたかどうか
  //     html.classList.add('is-scrollEnd')
  //   } else {
  //     html.classList.remove('is-scrollEnd')
  //   }
  // });
}

export default {
  open,
  close,
  bottom
}



// WEBPACK FOOTER //
// ./src/model/scrollPosition.js